import { useMutation, useQueryClient } from "@tanstack/react-query";
import SupportalAPI from "../../../../api/api/SupportalAPI";
import { useState } from "react";
import { getErrorMessage } from "../../../../utils/GeneralUtils";

export interface BulkAddUsersProps {
  cloudID: string;
  emails: string[];
  sendEmailInvite?: boolean;
  defaultPermissionID?: string;
}

export default function useBulkAddUsers() {
  const [successEmails, setSuccessEmails] = useState<string[]>([]);
  const [failedEmails, setFailedEmails] = useState<
    { email: string; reason: string }[]
  >([]);
  const [error, setError] = useState<string | null>(null);

  const client = useQueryClient();

  const reset = () => {
    setSuccessEmails([]);
    setFailedEmails([]);
    setError(null);
  };

  const bulkAdd = useMutation({
    mutationFn: async (props: BulkAddUsersProps) => {
      setError(null);
      return SupportalAPI.bulkAddUsers(props).then((data) => data.data.data);
    },
    onSuccess: (data, { cloudID }) => {
      client.invalidateQueries({
        queryKey: ["cloud", cloudID],
      });

      setSuccessEmails(data.successEmails);
      setFailedEmails(data.failedEmails);
    },
    onError: (err) => {
      setError(getErrorMessage(err));
    },
  });

  return {
    bulkAdd: bulkAdd.mutate,
    bulkAdding: bulkAdd.isPending,
    finished: !!successEmails.length || !!failedEmails.length,
    successEmails: successEmails,
    failedEmails: failedEmails,
    error: error,
    reset: reset,
  };
}
